<template>
  <div class="user-info-wrapper">
    <Avatar :user="user" />
    <div class="user-info-wrapper__info">
      <span class="user-name">
        <strong data-test-id="user-name">{{ user?.firstName }} {{ user?.lastName }}</strong>
      </span>
      <div v-if="subInfo" class="user-sub-info-line">
        <p data-test-id="user-sub-info" class="user-sub-info" :data-sub-info-copyable="isSubInfoCopyable">
          {{ subInfo }}
        </p>
        <button
          v-if="isSubInfoCopyable"
          type="button"
          class="user-sub-info__copy"
          data-test-id="user-sub-info-copy"
          :aria-label="t('user.info.copyEmail')"
          :title="t('user.info.copyEmail')"
          @click.stop="copySubInfo"
        >
          <CopyIcon color="black" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CopyIcon from '@/features/ui/components/icons/copy-icon.vue'
import Avatar from '@/features/users/components/avatar/avatar.vue'
import type { V2UserDataType } from '@/features/users/types'
import useToast from '@/hooks/use-toasts.hook'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()
const toast = useToast()

const props = defineProps<{
  user: V2UserDataType
  subInfo?: string
  isSubInfoCopyable?: boolean
}>()

async function copySubInfo() {
  if (!props.subInfo) return

  try {
    await navigator.clipboard.writeText(props.subInfo)
    toast.success(t('user.info.copyEmail.success'))
  } catch {
    toast.error(t('error.common'))
  }
}
</script>

<style lang="scss">
@import './user-info.scss';
</style>
